"use client";

import Link from "next/link";
import { Home } from "lucide-react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

export default function NotFound() {
  return (
    <main>
      <Header />
      <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 px-4">
        <div className="text-center">
          <div className="mb-8">
            <img
              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-foLsQlCfuwvd1k1X5x70v1WTdIAx5S.png"
              alt="La Plage Meta Verse"
              className="h-24 mx-auto mb-4"
            />
            {/* <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1> */}
            <h2 className="text-2xl font-semibold text-gray-700 mb-2">
              Page Not Found
            </h2>
            <p className="text-gray-600 mb-8 max-w-md">
              Sorry, we couldn't find the page you're looking for. The page
              might have been moved or doesn't exist.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-primary hover:bg-primary/90 text-white px-6 py-3 rounded-md font-medium transition-colors duration-200">
              <Link href="/" className="flex items-center gap-2">
                <Home className="mr-2 h-4 w-4" />
                Go to Home
              </Link>
            </button>
          </div>

          <div className="mt-8 text-sm text-gray-500">
            <p>
              © {new Date().getFullYear()} La Plage Cooperative. All rights
              reserved.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </main>
  );
}
